import { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Form, Formik } from 'formik';

import { SingleSelect } from '@/common';
import { FilterModalLayout, FilterPopUpValues } from '@/components/layouts';
import { PAGE_SIZE } from '@/constants';
import { AuthContext } from '@/contexts';
import { useGetAllOrganizations } from '@/services';
import { Organization, PlaylistFilterProps, SelectOptionProps } from '@/types';

export const Filters = ({ reset, apply, onClose, filterByOrganization }: PlaylistFilterProps) => {
  const [t] = useTranslation('common');
  const { currentUserData: currentUser } = useContext(AuthContext);
  const [searchOrganization, setSearchOrganization] = useState<string>('');
  const {
    data: allOrganizations,
    fetchNextPage,
    hasNextPage
  } = useGetAllOrganizations(PAGE_SIZE, searchOrganization);
  const getOrganizationOptions = () => {
    return allOrganizations?.pages.flatMap((page) =>
      page.data?.items.map((organization: Organization) => ({
        value: organization.id,
        label: organization.name
      }))
    ) as SelectOptionProps[];
  };

  return (
    <Formik
      initialValues={{
        filterByOrganization: filterByOrganization ?? null
      }}
      onSubmit={() => undefined}>
      {({ setFieldValue, values }) => (
        <Form>
          <FilterModalLayout
            apply={apply as (values: FilterPopUpValues) => void}
            reset={reset}
            onClose={onClose}
            values={values}>
            <SingleSelect
              isClearable
              label={t('organization')}
              id='filterByOrganization'
              options={
                currentUser?.organizations && currentUser.organizations.length >= 2
                  ? currentUser?.organizations?.map((orgs: Organization) => ({
                      value: orgs.id,
                      label: orgs.name
                    }))
                  : getOrganizationOptions()
              }
              value={values.filterByOrganization}
              handleChange={(value) =>
                setFieldValue('filterByOrganization', value as SelectOptionProps)
              }
              placeholder={t('selectOrganization')}
              fetchNextPage={fetchNextPage}
              hasNextPage={hasNextPage}
              isSearchable={true}
              handleInputChange={(inputValue: string) => setSearchOrganization(inputValue)}
            />
          </FilterModalLayout>
        </Form>
      )}
    </Formik>
  );
};
